//---------------------
// 캠페인
//---------------------

//서울특별시 x 내집스캔 X KCB
const campaignRouter = [
  {
    path: "/campaign/seoul",
    name: "campaign-seoul",
    component: () => import("../views/campaign/seoul/SeoulLandingView.vue"),
  },
  {
    // 인천 캠페인 종료(NZSC-3218): 랜딩 진입 차단 — 홈으로 redirect.
    // IncheonLandingView.vue 컴포넌트는 보존(소프트 종료). 재오픈 시 component 라우트로 복구.
    path: "/campaign/incheon",
    redirect: "/",
  },
];

export default campaignRouter;
